import React from "react";

interface FetchErrorStateProps {
  error: string;
  onRetry: () => void;
}

const FetchErrorState: React.FC<FetchErrorStateProps> = ({
  error,
  onRetry,
}) => {
  return (
    <div className="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center py-10">
      <span className="mb-4 text-red-500">{error}</span>
      <button
        className="rounded bg-brand-500 px-4 py-2 text-white transition hover:bg-brand-600"
        onClick={onRetry}
      >
        Retry
      </button>
    </div>
  );
};

export default FetchErrorState;
